import React from 'react';
import { Wine, Calendar, Plus } from 'lucide-react';
import { Button } from '../ui/button';
import { formatDate } from './diningConstants';

export function DiningEventsSection({ diningEvents, onAddEvent }) {
    return (
        <div className="space-y-6" data-testid="dining-events-section">
            <div className="flex justify-between items-center">
                <div>
                    <h2 className="text-2xl font-bold">Dining Events</h2>
                    <p className="text-muted-foreground">Wine tastings, chef's tables, themed dinners</p>
                </div>
                <Button onClick={onAddEvent} className="bg-rose-600 hover:bg-rose-700" data-testid="add-dining-event-btn">
                    <Plus className="w-4 h-4 mr-2" />
                    Add Event
                </Button>
            </div>
            
            {diningEvents.length === 0 ? (
                <div className="bg-stone-100 rounded-xl p-12 text-center">
                    <Wine className="w-12 h-12 text-stone-300 mx-auto mb-3" />
                    <p className="text-stone-500 mb-4">No dining events scheduled</p>
                    <Button onClick={onAddEvent} className="bg-rose-600 hover:bg-rose-700">
                        Create First Event
                    </Button>
                </div>
            ) : (
                <div className="space-y-3">
                    {diningEvents.map(event => (
                        <div key={event.id} className="bg-white rounded-xl p-4 border border-stone-200" data-testid={`dining-event-${event.id}`}>
                            <div className="flex items-start justify-between">
                                <div className="flex-1">
                                    <h3 className="font-semibold text-stone-800">{event.title}</h3>
                                    <p className="text-sm text-stone-500 mt-1">{event.description}</p>
                                    <div className="flex items-center gap-4 mt-2 text-sm">
                                        <span className="text-stone-600">
                                            <Calendar className="w-4 h-4 inline mr-1" />
                                            {formatDate(event.date)} at {event.time}
                                        </span>
                                        <span className="text-rose-600 font-medium">{event.price}</span>
                                        <span className="text-stone-500">
                                            {event.current_bookings}/{event.capacity} booked
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}

export default DiningEventsSection;
